import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {catchError} from 'rxjs/operators';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RecentlySeenService {
  constructor(private readonly http: HttpClient) {}

  public captureRecentlyViewedURL(urlId: string): Observable<any> {
    return this.http
      .post(`${environment.API_ENDPOINT}/recent-items/${urlId}`, {type: 'url'})
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    return throwError(() => error);
  }
}
